import types from '../types/review'
import {Map} from 'immutable'
import startTypes from '../types/start'

const initialRoot = Map({
  comment: '',
  isSaving: false,
  isConfirming: false,
  error: '',
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case startTypes.CREATE_RENT_SUCCESS:
      return state.set('comment', action.payload.rent.Comments)
    case types.SET_COMMENT:
      return state.set('comment', action.payload.value)
    case types.SAVE_ADD_COMMENT:
      return state.merge(asyncStart('isSaving'))
    case types.SAVE_ADD_COMMENT_SUCCESS:
      return state.merge(asyncSuccess('isSaving'))
    case types.SAVE_ADD_COMMENT_FAIL:
      return state.merge(asyncFail('isSaving', action.payload.error))
    case types.CONFIRM:
      return state.merge(asyncStart('isConfirming'))
    case types.CONFIRM_SUCCESS:
      return state.merge(asyncSuccess('isConfirming'))
    case types.CONFIRM_FAIL:
      return state.merge(asyncFail('isConfirming', action.payload.error))
    default:
      return state
  }
}

function asyncStart(key) {
  return {
    [key]: true,
    error: '',
  }
}

function asyncSuccess(key) {
  return {
    [key]: false,
    error: '',
  }
}

function asyncFail(key, error) {
  return {
    [key]: false,
    error,
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/rent/reducers/review.js